import { t } from './i18n';

const imageCodeTypes = [
    {
        code: 'QRCODE_URL',
        name: 'QR URL',
        width: 200,
        height: 200,
        barcodeType: 'QR_CODE',
        model: {
            imageCodeUrl: {
                dataType: 'string',
                sample: 'https://example.tld',
                name: t('imageCodeURL'),
            },
        },
    },
    {
        code: 'QRCODE_PAYMENT',
        name: t('imageQrCodePayment'),
        width: 300,
        height: 300,
        barcodeType: 'QR_CODE',
        model: {
            imageCodeAccount: {
                dataType: 'string',
                sample: '9876654321/1234',
                name: t('imageQrCodePaymentAccount'),
            },
            imageCodeAmount: {
                dataType: 'number',
                sample: '0.1',
                name: t('imageQrCodePaymentAmount'),
            },
            imageCodeCurrency: {
                dataType: 'string',
                sample: 'CZK',
                name: t('imageQrCodePaymentCurrency'),
            },
            imageCodeDateTs: {
                dataType: 'string',
                sample: '2050-01-01',
                name: t('imageQrCodePaymentDate'),
            },
            imageCodeVS: {
                dataType: 'string',
                sample: '1234567',
                name: t('imageQrCodePaymentVS'),
            },
            imageCodeKS: {
                dataType: 'string',
                sample: '0308',
                name: t('imageQrCodePaymentKS'),
            },
            imageCodeSS: {
                dataType: 'string',
                sample: '1234',
                name: t('imageQrCodePaymentSS'),
            },
            imageCodeMessage: {
                dataType: 'string',
                sample: 'Payment message',
                name: t('imageQrCodePaymentMessage'),
            },
        },
    },
    {
        code: 'QRCODE_TEXT',
        name: 'QR Text',
        width: 200,
        height: 200,
        barcodeType: 'QR_CODE',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'QR Text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'AZTEC',
        name: 'AZTEC',
        width: 200,
        height: 200,
        barcodeType: 'AZTEC',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'Aztec text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'CODE_128',
        name: 'CODE 128',
        width: 300,
        height: 100,
        barcodeType: 'CODE_128',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'Code128 text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'CODE_39',
        name: 'CODE 39',
        width: 300,
        height: 100,
        barcodeType: 'CODE_39',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'Code39 text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'CODE_93',
        name: 'CODE 93',
        width: 300,
        height: 100,
        barcodeType: 'CODE_93',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'Code93 text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'DATA_MATRIX',
        name: 'DATA MATRIX',
        width: 200,
        height: 200,
        barcodeType: 'DATA_MATRIX',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: 'DataMatrix text',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'EAN_8',
        name: 'EAN 8',
        width: 200,
        height: 100,
        barcodeType: 'EAN_8',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: '12345670',
                name: t('imageCodeText'),
            },
        },
    },
    {
        code: 'EAN_13',
        name: 'EAN 13',
        width: 200,
        height: 100,
        barcodeType: 'EAN_13',
        model: {
            imageCodeText: {
                dataType: 'string',
                sample: '5901234123457',
                name: t('imageCodeText'),
            },
        },
    },
];

const extractSamples = (samples, model) => {
    Object.keys(model).forEach((item) => {
        samples[item] = model[item].sample;
    });
    return samples;
};

const extractUiconfig = (uiConfig, model) => {
    Object.keys(model).forEach((item) => {
        uiConfig[item] = model[item].name;
    });
    return uiConfig;
};

export const setPlaceholderRequiredKeys = (placeholder, data) => {
    placeholder.model = [
        'imageCodeType',
        'imageCodeBarcodeType',
        'imageCodeWidth',
        'imageCodeHeight',
    ];
    placeholder.sample[0] = {
        imageCodeType: data.code,
        imageCodeBarcodeType: data.barcodeType,
        imageCodeWidth: data.width,
        imageCodeHeight: data.height,
    };
    placeholder.uiConfig.imageCodeType = t('imageCodeType');
    placeholder.uiConfig.imageCodeBarcodeType = data.barcodeType;
    placeholder.uiConfig.imageCodeWidth = t('imageCodeWidth');
    placeholder.uiConfig.imageCodeHeight = t('imageCodeHeight');
};

export const transformGroup = (placeholder, data) => {
    placeholder.model = placeholder.model.concat(Object.keys(data.model));
    placeholder.sample[0] = extractSamples(placeholder.sample[0], data.model);
    placeholder.uiConfig = extractUiconfig(placeholder.uiConfig, data.model);
};

export const getImageCodeTypes = () => {
    return imageCodeTypes;
};

export const useImageCodes = () => {
    return {
        setPlaceholderRequiredKeys: setPlaceholderRequiredKeys,
        transformGroup: transformGroup,
        getImageCodeTypes: getImageCodeTypes,
    };
};

export const useuseImageCodes = {
    setPlaceholderRequiredKeys: setPlaceholderRequiredKeys,
    transformGroup: transformGroup,
    getImageCodeTypes: getImageCodeTypes,
};

export default useImageCodes;
